import { Layout, Space, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { localeLabel, readsArabicContent } from "utils/locale";
import GAMap from "tokens/GAMap.json";
import ReactGA from "react-ga4";

const { Footer } = Layout;
const { Text, Link } = Typography;

interface FooterStyles {
  flexDirection: "row" | "column";
  copyrightRank: number;
  height: number;
}

const mobileFooter = new Map<string, FooterStyles>([
  [
    "Styles",
    {
      flexDirection: "column",
      copyrightRank: -1,
      height: 154,
    },
  ],
]);

const pcFooter = new Map<string, FooterStyles>([
  [
    "Styles",
    {
      flexDirection: "row",
      copyrightRank: 0,
      height: 70,
    },
  ],
]);

const footerLinksAR = new Map([
  ["termsAndConditions", "/ara/terms-and-conditions"],
  ["privacyPolicy", "/ara/privacy-policy"],
  ["helpCenter", "/ara/مركز-المساعدة"],
]);

const footerLinksEN = new Map([
  ["termsAndConditions", "/en/terms-and-conditions"],
  ["privacyPolicy", "/en/privacy-policy"],
  ["helpCenter", "/en/help-center"],
]);

const trackGAEvent = (action: string) => {
  ReactGA.event({
    category: GAMap.footer.CATEGORY,
    action: action,
  });
};

const QFooter = ({ broken }: { broken: boolean }) => {
  const { t } = useTranslation();
  const footerDirection = (broken ? mobileFooter.get("Styles") : pcFooter.get("Styles"))
    ?.flexDirection;
  const copyrightRank = (broken ? mobileFooter.get("Styles") : pcFooter.get("Styles"))
    ?.copyrightRank;
  // qoyod.com is published in Arabic and English only, so this is a question about the language
  // of the linked content: ur/hi/bn readers get the English pages, not the Arabic ones.
  const footerLinks = readsArabicContent() ? footerLinksAR : footerLinksEN;

  return (
    <Footer
      style={{
        textAlign: "center",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        paddingInline: 32,
        flexDirection: footerDirection,
        gap: 20,
        position: "absolute",
        bottom: 0,
      }}
    >
      <Space size="large" style={{ display: "flex" }}>
        {/* The name of the interface language, which exists for all five locales — neither an
            en/ar content choice nor a direction one, so it comes from the shared label table. */}
        <Text style={{ wordBreak: "unset" }}>{localeLabel()}</Text>
      </Space>
      <Space size="large" style={{ display: "flex", order: copyrightRank }}>
        <Text style={{ wordBreak: "unset" }}>
          {t("activerecord.attributes.devise.qoyod")} &#169; {new Date().getFullYear()}
        </Text>
      </Space>
      <Space size="large" style={{ display: "flex" }}>
        <Link
          style={{ wordBreak: "unset" }}
          onClick={() => {
            trackGAEvent(GAMap.footer.termsAndConditions);
          }}
          href={footerLinks.get("termsAndConditions")}
        >
          {t("activerecord.attributes.home.terms_of_use")}
        </Link>
        <Link
          style={{ wordBreak: "unset" }}
          onClick={() => {
            trackGAEvent(GAMap.footer.privacyPolicy);
          }}
          href={footerLinks.get("privacyPolicy")}
        >
          {t("activerecord.attributes.home.privacy_policy")}
        </Link>
        <Link
          style={{ wordBreak: "unset" }}
          onClick={() => {
            trackGAEvent(GAMap.footer.FAQ);
          }}
          href={footerLinks.get("helpCenter")}
        >
          {t("activerecord.attributes.home.faq")}
        </Link>
      </Space>
    </Footer>
  );
};

export default QFooter;
